<template>
    <div class="multicalculo row">
        <input type="hidden" id="token" name="token" :value="tokenIntegration" v-if="tokenIntegration">
        <PropostaLoading />

        <div class="col-xs-12 no-padding">
            <form ref ="formQuotation">
                <input type="hidden" name="faye_channel" :value="faye.channel">

                <div id="quotation-data" :class="{ 'form-centered': centeredForm }">
                    <FormPartialQuotation :dataQuotation="quotation.data"/>
                    <FormPartialRenovation :renewal="quotation.data.renewal" />
                    <FormPartialCustomer :customer="quotation.data.customer" />
                    <FormPartialEnterprise :residence="quotation.data.residence" />
                    <FormPartialQuestionnaire :questionnaire="quotation.data.questionnaire" />
                    <FormPartialCoverage v-if="!showFormCustomer" :coverage="quotation.data.coverage"/>
                </div>

                <FormPartialResult v-if="!showFormCustomer" :insurers="quotation.config.insurers"/>

                <div class="row" :class="{ 'text-center': centeredButtonsForm }" v-if="showFormCustomer">
                    <div class="col-xs-12">
                        <hr>
                        <input type="hidden" name="form_customer" value="true">
                        <input class="btn btn-primary" type="submit" value="Solicitar cotação" @click.prevent="sendForm()" :disabled="disableButtonQuote">
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import FormPartialQuotation from 'shared/modules/QuotationNew/FormPartialQuotation.vue'
    import FormPartialCustomer from 'shared/modules/CustomerNew/FormPartialCustomer.vue'
    import PropostaLoading from 'shared/modules/Loading/Loading.vue'
    import FormPartialRenovation from 'shared/modules/RenovationNew/FormPartialRenovation.vue'
    import FormPartialEnterprise from './Residence/FormPartialEnterprise.vue'
    import FormPartialQuestionnaire from './Questionnaire/FormPartialQuestionnaire.vue'
    import FormPartialCoverage from './Coverage/FormPartialCoverage.vue'
    import FormPartialResult from './Result/FormPartialResult.vue'
    import _ from 'lodash'
    import moment from 'shared/helpers/moment'
    import jQuery from 'jquery'
    import axios from 'axios'

    export default {
        components: {
            PropostaLoading,
            FormPartialQuotation,
            FormPartialRenovation,
            FormPartialCustomer,
            FormPartialEnterprise,
            FormPartialCoverage,
            FormPartialResult,
            FormPartialQuestionnaire
        },
        data() {
            return {
                tipo: 'empresarial',
                disableButtonQuote: false,
                inputVal: null,
                quotation: {
                    config:
                    {
                        token: this.$root.$options.config.token,
                        insurers:[]
                    },
                    data:{
                        id: "",
                        quotation_date: moment().format('DD/MM/YYYY'),
                        validity_start: moment().format('DD/MM/YYYY'),
                        validity_end: moment().add(1, 'years').format('DD/MM/YYYY'),
                        renewal:{
                            insurer: 'new',
                            bonus_last: '',
                            bonus_current: '',
                            claim_amount: 0,
                            prior_policy_end: '',
                            prior_policy: '',
                            prior_ic: ''
                        },
                        customer:{
                            document: '',
                            name: '',
                            email: '',
                            phone: '',
                            celphone: ''
                        },
                        residence:{
                            zip_code: '',
                            street: '',
                            number: '',
                            complement: '',
                            neighborhood: '',
                            city: '',
                            state: '',
                            walk: '',
                            type_construction: '',
                            location: '',
                            extinguisher: false,
                            hydrant: false,
                            sprinkler: false,
                            smoke_detector: false,
                            fire_brigade: false,
                            local_alarm: false,
                            closed_circuit: false,
                            security_24h: false,
                            grid_tetra_lock: false,
                            infrared_sensor: false,
                            monitored_alarm: false,
                            activity: '',
                            activity_cnae: '',
                            activity_cnae_company: []
                        },
                        questionnaire:{
                            storage_material: false,
                            wasted_currency: false,
                            historical_heritage: false,
                            metal_structure: false,
                            boxes_electronics: false,
                            isopainel: false,
                            construction_renovation: false
                        },
                        coverage: {
                            assistance: '',
                            sum: '',
                            new_property: false,
                            building_value: 0,
                            content_value: 0,
                            basic: 0,
                            electrical_damages: 0,
                            glasses: 0,
                            theft_goods: 0,
                            theft_values: 0,
                            equipments: 0,
                            wind: 0,
                            vehicle_impact: 0,
                            landslip: 0,
                            adverts: 0,
                            rent_payment: 0,
                            turmoil: 0,
                            recomposition_documents: 0,
                            liability_operations: 0,
                            liability_employer: 0,
                            moral_damages: 0,
                            fixed_expenses: 0,
                            business_interruption: 0,
                            leaks: 0,
                            shower: 0,
                            loyalty: 0
                        }
                    }
                }
            }
        },
        computed: {
            faye() {
                return this.$store.state.faye
            },
            showFormCustomer(){
                return this.$root.$options.config.showFormCustomer
            },
            widthForm() {
                return this.$root.$options.config.widthForm
            },
            centeredForm() {
                return this.$root.$options.config.centeredForm
            },
            centeredButtonsForm(){
                return this.$root.$options.config.centeredButtonsForm
            },
            tokenIntegration(){
                return this.$root.$options.config.token
            }
        },
        watch: {
            '$store.state.quotation': {
                handler(newQuotation) {
                    if (!newQuotation) return
                    
                    // Atualiza apenas validity_start e validity_end quando onLoadFields é chamado
                    if (newQuotation.data && newQuotation.data.data) {
                        // Se o quotation do store tiver a estrutura com data
                        if (newQuotation.data.data.validity_start !== undefined) {
                            const oldValue = this.quotation.data.validity_start
                            this.quotation.data.validity_start = newQuotation.data.data.validity_start
                        }
                        if (newQuotation.data.data.validity_end !== undefined) {
                            const oldValue = this.quotation.data.data.validity_end
                            this.quotation.data.validity_end = newQuotation.data.data.validity_end
                        }
                    } else {
                        // Se for apenas os campos diretos  
                        if (newQuotation.data.data.validity_start !== undefined) {
                            const oldValue = this.quotation.data.validity_start
                            this.quotation.data.validity_start = newQuotation.data.data.validity_start
               
                        }
                        if (newQuotation.data.data.validity_end !== undefined) {
                            const oldValue = this.quotation.data.validity_end
                            this.quotation.data.validity_end = newQuotation.data.data.validity_end
                        }
                    }
                },
                deep: true,
                immediate: false
            }
        },
        mounted() {
            this.getAuthorizationToken()
            this.$root.$options.eventBus.$on('onValidateEnterpriseForm', (insurer = null) => this.validateForm(insurer))
            this.$root.$options.eventBus.$on('onValidatedQuotation', () => this.enableDisableButtonsQuote(false))
            this.$root.$options.eventBus.$on('onSavingQuotation', () => this.enableDisableButtonsQuote(true))
            this.$root.$options.eventBus.$on('onSavedQuotation', () => this.enableDisableButtonsQuote(false))
            this.$root.$options.eventBus.$on('onErrorQuotation', () => this.enableDisableButtonsQuote(false))

            this.$store.commit('updateFayeSetup', {
                channel: '/faye/' + this.$store.getters['generateUUID'],
                url: this.$root.$options.config.environment.fayeUrl
            })

            if ( !this.showFormCustomer && this.$root.$options.config.quotationId > 0 ) {
                this.mountFayeConfig(this.$root.$options.config.quotationId)
                this.$store.dispatch('startFayeClient')
            }
        },
        methods: {
            getAuthorizationToken(){
                this.$store.commit('setAutomationBearer', this.$root.$options.config.automationBearer);

                let stateBearer = this.$store.getters['automationBearer']

                if (!stateBearer) {
                    axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/auths/token', {}, {
                        headers: {'Authorization': this.$store.getters['generateAuthenticationToken'] }
                    }).then(response => {
                        let bearer = response.data['token'];

                        this.$store.commit('setAutomationBearer', bearer);
                        this.initializeDataForm();
                    })
                }else{
                    this.initializeDataForm();
                }
            },
            initializeDataForm(){
                this.initInsurers(); 
                this.initQuotation();

                this.$root.$options.eventBus.$emit('onAuthorizedToken')
            },
            mountFayeConfig(channelId) {
                this.$store.commit('updateFayeSetup', {
                    channel: '/faye/' + channelId,
                    url: this.$root.$options.config.environment.fayeUrl
                })
            },
            initInsurers() {
                let self = this;
                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/company-list',
                    {
                        config: {
                            token: this.$root.$options.config.token,
                            business: "enterprise"
                        }
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                ).then(response => {
                    self.quotation.config.insurers = response.data.data;
                    if(!this.showFormCustomer)
                        this.$store.commit('setEnterpriseInsurers', self.quotation.config.insurers)
                        this.$root.$options.eventBus.$emit('onReceiveCompanyList')
                })

            },
            initQuotation(){
                let self = this;
                this.$store.commit('setQuotationId', null)

                if(!this.$root.$options.config.quotationId)
                    return

                if (!this.$root.$options.config.loadResult)
                    return

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + "/api/enterprise/version/1.0/show", 
                    {
                        config: {
                            token: this.$root.$options.config.token
                        },
                        data: {
                            guid: this.$root.$options.config.quotationId
                            }
                    },{
                        headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }).then(response => {
                        this.$store.commit('setQuotation', response.data)}
                    );
            },
            validateForm(insurer){
                let errorFieldFound = false

                this.$children.forEach(child => {
                    child.$validator.validateAll().then((result) => {
                        if ( ! result )
                            errorFieldFound = true
                    })

                    if (child.$el.className == 'sessao-resultados') {
                        child.$children.forEach(child => {
                            child.$validator.validateAll().then((result) => {
                                if ( ! result ) errorFieldFound = true
                            })
                        })
                    }
                })
                setTimeout(() => {
                    if(errorFieldFound){
                        this.$root.$options.eventBus.$emit('onValidatedQuotation')
                        this.scrollToTop()
                        return
                    }

                    if(insurer){
                        this.sendFormInsurerQuote(insurer)
                    }
                    else
                    {
                        this.sendFormAllInsurers()
                    }
                }, 200)
            },
            scrollToTop(){
                this.$nextTick(() => {
                    if( jQuery(this.$refs.formQuotation).find('.has-error').length > 0 )
                    {
                        this.$store.dispatch(
                            'scrollToTop',
                            jQuery(this.$refs.formQuotation).find('.has-error').first().offset().top - 90
                        )
                    }
                })
            },
            enableDisableButtonsQuote(active){
                this.disableButtonQuote = active
            },
            sendForm(){
                this.$root.$options.eventBus.$emit('onSavingQuotation')
                this.$root.$options.eventBus.$emit('onValidateEnterpriseForm')
            },
            sendFormAllInsurers(){
                let extension_guid = document.getElementById('extension-guid') ? document.getElementById('extension-guid').value : null;
                let extension_version = document.getElementById('extension-version') ? document.getElementById('extension-version').value : null;
                let connected_backup = document.getElementById('extension-backup') ? document.getElementById('extension-backup').value : null;

                let object_deep = _.cloneDeep(this.quotation);
                object_deep.config.extension_guid = extension_guid
                object_deep.config.extension_version = extension_version
                object_deep.config.connected_backup = connected_backup

                let url = '/api/enterprise/version/1.0/calculate'

                if(this.showFormCustomer)
                    url = '/api/enterprise/version/1.0/save-customer'

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + url, 
                    object_deep,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                )
                .then(response => {
                    if (response.data.status == 'VALIDACAO'){
                        this.applyErrorsQuotationResponse(response.data.validations)
                    }
                    else {
                        this.$store.commit('setQuotationId', response.data.guid)
                        this.mountFayeConfig(response.data.guid)
                        this.$store.dispatch('startFayeClient')
                        this.quotation.data.guid = response.data.guid
                        this.$store.dispatch('onSaveQuotation', this.quotation)
                        this.$root.$options.eventBus.$emit('onSavedQuotation')
                        this.$root.$options.eventBus.$emit('onInitQuote', this.quotation.config.insurers)
                    }
                })
            },
            sendFormInsurerQuote(insurer){
                this.insurerQuote = null

                let extension_guid = document.getElementById('extension-guid') ? document.getElementById('extension-guid').value : null;
                let extension_version = document.getElementById('extension-version') ? document.getElementById('extension-version').value : null;
                let connected_backup = document.getElementById('extension-backup') ? document.getElementById('extension-backup').value : null;

                let object_deep = _.cloneDeep(this.quotation);
                object_deep.config.insurers = [insurer]
                object_deep.config.extension_guid = extension_guid
                object_deep.config.extension_version = extension_version
                object_deep.config.connected_backup = connected_backup

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/calculate', 
                    object_deep,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                )
                .then(response => {
                    if (response.data.status == 'VALIDACAO'){
                        this.applyErrorsQuotationResponse(response.data.validations)
                    }
                    else {
                        this.$store.commit('setQuotationId', response.data.guid)
                        this.mountFayeConfig(response.data.guid)
                        this.$store.dispatch('startFayeClient')
                        this.quotation.data.guid = response.data.guid
                        this.$store.dispatch('onSaveQuotation', this.quotation)
                        this.$root.$options.eventBus.$emit('onSavedQuotation')
                        this.$root.$options.eventBus.$emit('onInitQuote', [insurer])
                    }
                })
            },
            addQuotationIdInFormData(formData){
                if(this.$store.getters['quotationId'])
                    formData.append('cotacao[id]', this.$store.getters['quotationId'])

                return formData
            },
            addConfigInFormData(formData) {
                if(this.$root.$options.config.partnerReference)
                    formData.append('partner_reference', this.$root.$options.config.partnerReference)

                if(this.$root.$options.config.integrationIntercept)
                    formData.append('integration_intercept', this.$root.$options.config.integrationIntercept)

                return formData
            },
            applyErrorsQuotationResponse(errors){
                this.$children.forEach(child => {
                    for(let error in errors)
                        child.errors.add(error, errors[error][0])
                })

                this.scrollToTop()
            },
            getResultId(){
                // Esperamos que esse método retorne o guid do calculo para gravarmos no banco.
                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api​/enterprise​/version​/1.0​/get-id',
                    {
                        data: {
                            guid: this.quotation.data.id
                        },
                        config: {
                            token: this.$root.$options.config.token
                        }
                    },
                    {
                        // talvez não precise desse bloco
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                ).then(response => {
                    return ""
                    // TODO: Retornar guid do calculo
                })
            }
        }
    }
</script>
<style src="../sass/app.scss" lang="sass"></style>


// WEBPACK FOOTER //
// App.vue?ac375a5e